import React, { useEffect, useState } from "react";
import { StampPage } from "./styled/landing";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router";

const Coupon = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const noValue = urlParams.get("no");

    if (noValue) {
      openApp(`?couponNo=${noValue}`);
      sessionStorage.setItem("coupon", JSON.stringify(noValue));
    }
  }, []);

  const openMonoti = async () => {
    navigate("/login");
  };

  return (
    <StampPage>
      <h2 className="logo" onClick={() => navigate("/")}>
        MONOTI
      </h2>
      <img src="/img/landing/coupon.png" onClick={() => openMonoti()} />
    </StampPage>
  );
};

export default Coupon;
